<template>
  <div>
    <ghosthouse v-if="resultData.prefix === 'GH'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <solarspace v-if="resultData.prefix === 'SOLAR'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <joker v-if="resultData.prefix === 'JOKER'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <monster v-if="resultData.prefix === 'MONSTER'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <thaidessert v-if="resultData.prefix === 'TDESSERT'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <kraken v-if="resultData.prefix === 'KRAKEN'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <vampire v-if="resultData.prefix === 'VAMPIRE'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <romaplus v-if="resultData.prefix === 'ROMAPLUS'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <super-bros v-if="resultData.prefix === 'SUPERBROS'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <jinsung v-if="resultData.prefix === 'JINSUNG'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <richwater v-if="resultData.prefix === 'RICHWATER'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <snowprinces v-if="resultData.prefix === 'SNOWPRINCESS'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <angrybird v-if="resultData.prefix === 'ANGRYBIRD'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <sushi v-if="resultData.prefix === 'SUSHI35'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <crazyworm v-if="resultData.prefix === 'CRAZYWORM'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <doraemon v-if="resultData.prefix === 'DORAEMON'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <peekaboo v-if="resultData.prefix === 'PEAKABOO'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <wrath-of-egypt v-if="resultData.prefix === 'EGYPT'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <grand-shine v-if="resultData.prefix === 'GRANDSHRINE'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <ninfruit v-if="resultData.prefix === 'FRUITNINJA'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <krahung v-if="resultData.prefix === 'HUNGRYKRAHUNG'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <shiba v-if="resultData.prefix === 'SHIBAMOGUL'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <guardian-wizard v-if="resultData.prefix === 'GUARDIANWIZARD'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <hoyes-yellow v-if="resultData.prefix === 'HOYESYELLOW'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <shikkadood v-if="resultData.prefix === 'SHIKKADOOD'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <blessingox v-if="resultData.prefix === 'BLESSINGOX'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <moemoe v-if="resultData.prefix === 'MOEMOECUTE'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <centilliongod v-if="resultData.prefix === 'CENTILLIONGOD'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <dinopop v-if="resultData.prefix === 'DINOPOP'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <punkstar v-if="resultData.prefix === 'PUNKSTAR'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <squidgame v-if="resultData.prefix === 'SQUIDTOON'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <govdisco v-if="resultData.prefix === 'GOVDISCO'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <blessing-tiger v-if="resultData.prefix === 'BLESSINGTIGER'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <mermaid v-if="resultData.prefix === 'MERMAID'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <valentine v-if="resultData.prefix === 'CUPIDGARDEN'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <virus v-if="resultData.prefix === 'VIRUS'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <mjl v-if="resultData.prefix === 'MAHJONGLEGEND'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <petrenger v-if="resultData.prefix === 'PETRANGER'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <veggiesbonanza v-if="resultData.prefix === 'VEGGIESBONANZA'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <mafiaways v-if="resultData.prefix === 'MAFIAWAYS'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <kwak v-if="resultData.prefix === 'KWAK'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <lucky-nangkwak v-if="resultData.prefix === 'LUCKYNANGKWAK'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <dinogems v-if="resultData.prefix === 'DINOGEMS'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <epicofaztec v-if="resultData.prefix === 'EPICOFAZTEC'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <kingdomz v-if="resultData.prefix === 'KINGDOM'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <fishingParadise v-if="resultData.prefix === 'FISHINGPARADISE'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <alice v-if="resultData.prefix === 'ALICE'" :data="resultData" :lang="$i18n.locale" :imgLang="imageLang" />
    <mahjongXmas v-if="resultData.prefix === 'MAHJONGXMAS'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <blessingDragon v-if="resultData.prefix === 'BLESSINGDRAGON'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <MonkeyKing v-if="resultData.prefix === 'MONKEYKING'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <SubwayRunner v-if="resultData.prefix === 'SUBWAYRUNNER'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />
    <GuardianWealth v-if="resultData.prefix === 'GUARDIANWEALTH'" :data="resultData" :lang="$i18n.locale"
      :imgLang="imageLang" />

  </div>
</template>

<script>
import { FETCH_GAME_RESULT_REQUEST } from '../store/actions/report'
import Ghosthouse from './payTable/ghost'
import Solarspace from './payTable/solarSpace'
import Joker from './payTable/joker'
import Monster from './payTable/monster'
import Thaidessert from './payTable/thaiDessert'
import Kraken from './payTable/kraken'
import Vampire from './payTable/vampire'
import Romaplus from './payTable/romaplus.vue'
import SuperBros from './payTable/superBros'
import Jinsung from './payTable/jinsung.vue'
import Richwater from './payTable/richwater.vue'
import Snowprinces from './payTable/snowprinces.vue'
import Angrybird from './payTable/angrybird.vue'
import Sushi from './payTable/sushi.vue'
import Crazyworm from './payTable/crazyworm.vue'
import Doraemon from './payTable/doraemon.vue'
import Peekaboo from './payTable/peekaboo.vue'
import WrathOfEgypt from './payTable/wrathOfEgypt.vue'
import GrandShine from './payTable/grandShine.vue'
import Ninfruit from './payTable/ninfruit.vue'
import Krahung from './payTable/krahung.vue'
import Shiba from './payTable/shiba.vue'
import GuardianWizard from './payTable/guardianWizard.vue'
import HoyesYellow from './payTable/hoyesYellow.vue'
import Shikkadood from './payTable/shikkadood.vue'
import Blessingox from './payTable/blessingox.vue'
import Moemoe from './payTable/moemoe.vue'
import Centilliongod from './payTable/centilliongod.vue'
import Dinopop from './payTable/dinopop.vue'
import Punkstar from './payTable/punkstar.vue'
import Squidgame from './payTable/squidgame.vue'
import Govdisco from './payTable/govdisco.vue'
import BlessingTiger from './payTable/blessingTiger.vue'
import Mermaid from './payTable/mermaid.vue'
import Valentine from './payTable/valentine.vue';
import Virus from './payTable/virus.vue';
import Mjl from './payTable/mjl.vue';
import Petrenger from './payTable/petrenger.vue';
import Veggiesbonanza from './payTable/veggiesbonanza.vue';
import Mafiaways from './payTable/mafiaways.vue';
import LuckyNangkwak from './payTable/luckyNangkwak.vue';
import Dinogems from './payTable/dinogems.vue';
import Epicofaztec from './payTable/epicofaztec.vue';
import Kingdomz from './payTable/kingdomz.vue';
import fishingParadise from './payTable/fishingParadise.vue';
import Alice from './payTable/alice.vue'
import MahjongXmas from './payTable/mahjongXmas.vue'
import BlessingDragon from './payTable/blessingDragon.vue'
import MonkeyKing from './payTable/monkeyKing.vue'
import SubwayRunner from './payTable/subwayrunner.vue'
import GuardianWealth from './payTable/guardianWealth.vue'

export default {
  name: 'paytable-game',
  props: {
    data: Object,
  },
  components: {
    Ghosthouse,
    Solarspace,
    Joker,
    Monster,
    Thaidessert,
    Kraken,
    Vampire,
    SuperBros,
    Romaplus,
    Jinsung,
    Richwater,
    Snowprinces,
    Angrybird,
    Sushi,
    Crazyworm,
    Doraemon,
    Peekaboo,
    WrathOfEgypt,
    GrandShine,
    Ninfruit,
    Krahung,
    Shiba,
    GuardianWizard,
    HoyesYellow,
    Shikkadood,
    Blessingox,
    Moemoe,
    Centilliongod,
    Dinopop,
    Punkstar,
    Squidgame,
    Govdisco,
    BlessingTiger,
    Mermaid,
    Valentine,
    Virus,
    Mjl,
    Petrenger,
    Veggiesbonanza,
    Mafiaways,
    LuckyNangkwak,
    Dinogems,
    Epicofaztec,
    Kingdomz,
    fishingParadise,
    Alice,
    MahjongXmas,
    BlessingDragon,
    MonkeyKing,
    SubwayRunner,
    GuardianWealth
  },
  data() {
    return {
      prefix: '',
      resultData: {},
      paytable: {},
      imageLang: ''
    }
  },
  created() {
    this.setDefaultFavicon()
    this.queryPrefix()
  },

  methods: {
    queryPrefix() {
      const queryString = window.location.search;
      this.prefix = this.getParameterByName('prefix', queryString);
      this.$i18n.locale = this.getParameterByName('lang', queryString);
      this.paytable = this.getParameterByName('paytable', queryString);
      this.imageLang = this.fixLang(this.getParameterByName('lang', queryString));
      this.fetchGame()
    },
    fixLang(lang) {
      if (lang === 'cn') return 'zh';
      else if (lang === 'en' || lang === 'th' || lang === 'zh') return lang;
      else return 'en';
    },
    getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    setDefaultFavicon() {
      document.title = 'Askmeslot';
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = 'https://asset-images.asp78coll.com/sit/default/agent/favicon.svg';
    },
    async fetchGame() {
      let params = {
        prefix: this.prefix
      }
      await this.$store
        .dispatch(FETCH_GAME_RESULT_REQUEST, params)
        .then(res => {
          this.resultData = res.config;
          if (this.paytable) {
            let paytable = JSON.parse(this.paytable);
            this.resultData.config.payTable = paytable;
          }
        })
        .catch(err => {
          this.errorModel.code = err.code
          this.errorModel.message = err.message
        })
    }
  }
}
</script>
